module.exports = {"610822100":"府谷镇","610822101":"黄甫镇","610822103":"哈镇","610822104":"庙沟门镇","610822105":"新民镇","610822106":"孤山镇","610822107":"清水镇","610822108":"大昌汗镇","610822109":"古城镇","610822110":"三道沟镇","610822111":"老高川镇","610822112":"武家庄镇","610822113":"木瓜镇","610822114":"田家寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610822.json
// module id = 2862
// module chunks = 0